// Small shared helpers for the runtime.

const PREFIX = '[pagelet]'

export function warn(scope: string, err: unknown): void {
  console.warn(`${PREFIX} ${scope}:`, err)
}

/** Strip the common leading indentation from a block (markdown is indent-sensitive). */
export function dedent(text: string): string {
  const lines = text.replace(/^\n/, '').replace(/\s+$/, '').split('\n')
  let min = Infinity
  for (const line of lines) {
    if (!line.trim()) continue
    const indent = line.match(/^[ \t]*/)?.[0].length ?? 0
    if (indent < min) min = indent
  }
  if (!isFinite(min) || min === 0) return lines.join('\n')
  return lines.map((l) => l.slice(min)).join('\n')
}

/** camelCase / "primaryForeground" -> "primary-foreground" for CSS var names. */
export function kebab(s: string): string {
  return s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/_/g, '-').toLowerCase()
}

/** localStorage may be unavailable (sandboxed iframes, Claude.ai Artifacts) — degrade silently. */
export function safeGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    /* no-op */
  }
}
